<template>
  <page-header-wrapper>
    <a-card :bordered="false" :label-col="4" :wrapper-col="14">
      <a-divider orientation="left">
        <b>平台客服</b>
      </a-divider>
      <a-form-model ref="form" :model="form" :rules="rules" style="height: 700px">
        <a-form-model-item label="图片" prop="image" >
          <cos-upload :defaultList="form.imageArr" :count="1"
          @input="getImg($event, 'image')" type="image"></cos-upload>
          <span style="color: red">建议上传图片尺寸：375*164</span>
        </a-form-model-item>
        <a-form-model-item label="客户电话" prop="serviceTel" >
          <a-input v-model="form.serviceTel" placeholder="请输入客户电话" />
        </a-form-model-item>
<!--        <a-form-model-item label="微信客服" prop="wechatService" >-->
<!--          <file-upload :defaultList="form.wechatServiceArr" :count="1"-->
<!--                       @input="getImg($event, 'wechatService')" type="image"></file-upload>-->
<!--          <span style="color: red">建议上传图片尺寸：200*200</span>-->
<!--        </a-form-model-item>-->
        <a-form-model-item label="在线客户时间段" prop="onlineServiceTime" >
          <a-input v-model="form.onlineServiceTime" placeholder="请输入内容 8:00 - 18:00"  allow-clear />
        </a-form-model-item>
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm">
              保存
            </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { tableMixin } from '@/store/table-mixin'
import { getConfig, addConfig, updateConfig } from '@/api/customer/config'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'Config',
  components: {

  },
  mixins: [tableMixin],
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        image: null,
        imageArr:[],
        imageCount:1,
        serviceTel: null,
        wechatService: null,
        wechatServiceArr:[],
        wechatServiceCount:1,
        onlineServiceTime: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        serviceTel: [
          { required: true, message: '客户电话不能为空', trigger: 'blur' }
        ],
        onlineServiceTime: [
          { required: true, message: '在线客户时间段不能为空', trigger: 'blur' }
        ]
      }
    }
  },

  filters: {
  },
  created () {
    this.handleInfo()
  },
  activated() {
    this.handleInfo()
  },

  computed: {
  },
  watch: {
  },
  methods: {
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    handleInfo () {
      this.reset()
      getConfig().then(response => {
        this.form = response.data
        let that =this
        this.form.imageArr = []
        this.form.wechatServiceArr = []
        if(this.form.image){
          this.form.imageArr.push({
            uid: guid(8, 10),
            name: that.form.image,
            status: 'done',
            halfUrl: that.form.image,
            url: that.form.image,
            path: that.form.image
          })
        }
        if(this.form.wechatService){
          this.form.wechatServiceArr.push({
            uid: guid(8, 10),
            name: that.form.wechatService,
            status: 'done',
            halfUrl: that.form.wechatService,
            url: that.form.wechatService,
            path: that.form.wechatService
          })
        }
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        image: null,
        serviceTel: null,
        wechatService: null,
        onlineServiceTime: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateConfig(this.form).then(response => {
              this.$message.success(
                '操作成功',
                3
              )
              this.handleInfo()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(response => {
              this.$message.success(
                '操作成功',
                3
              )
              this.handleInfo()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
